import React from "react";

const News = () => {
  const news = [
    {
      id: "listing-1",
      title: "New Listing: Modern 2BR Apartment (City Center)",
      content:
        "Bright 2-bedroom apartment with balcony, open-plan kitchen, and secure parking. Ideal for young professionals or small families. Contact us to schedule a viewing.",
      imageUrl:
        "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?auto=format&fit=crop&w=1400&q=60",
    },
    {
      id: "listing-2",
      title: "New Listing: Modern Apartment (Stairs View)",
      content:
        "Clean, bright interior with a modern staircase design. Great layout, secure building, and close to key amenities. Contact us to book a viewing.",
      imageUrl:
        "https://images.unsplash.com/photo-1524758631624-e2822e304c36?auto=format&fit=crop&w=1400&q=60",
    },
  ];

  return (
    <div className="d-flex flex-column align-items-center w-100">
      <div className="video-title text-center">
        <h1 className="text-dark fw-medium mt-1 mb-1">Real Estate Updates</h1>
        <p className="text-info">{news.length} Updates</p>
      </div>

      {/* Center the cards container + limit width */}
      <div className="w-100 d-flex flex-column align-items-center">
        {news.map((item) => (
          <div
            className="card mb-3"
            key={item.id}
            style={{ width: "100%", maxWidth: "900px" }} // centered & responsive
          >
            <img
              src={item.imageUrl}
              alt={item.title}
              className="card-img-top"
              style={{ maxHeight: 420, objectFit: "cover" }}
            />
            <div className="card-body text-center">
              <h5 className="card-title text-dark">{item.title}</h5>
              <p className="mt-2 mb-0">{item.content}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default News;
